import { useRef } from 'react';
import { DescriptionOutlined } from '@mui/icons-material';
import { useGetAdviceCorrectionReport } from '@practium/features/api';
import { FormCard } from '@practium/ui';
import { ReportViewer, type ReportViewerHandle } from '../Reports/ReportViewer/ReportViewer';
import { ReportActionButtons } from '../Reports/ReportActionButtons/ReportActionButtons';
import styles from './TabPanel.module.css';
import laudoStyles from './LaudoTab.module.css';

export interface LaudoTabProps {
	adviceId: string;
}

export const LaudoTab = ({ adviceId }: LaudoTabProps) => {
	const { data, isLoading, isFetching, isError } = useGetAdviceCorrectionReport(adviceId);
	const viewerRef = useRef<ReportViewerHandle>(null);

	return (
		<div className={styles.panel}>
			<FormCard icon={<DescriptionOutlined />} title="Laudo">
				<div className={laudoStyles.toolbar}>
					<ReportActionButtons
						onPrint={() => viewerRef.current?.print()}
						onDownload={() => viewerRef.current?.download(`laudo-${adviceId}.pdf`)}
						disabled={!data}
					/>
				</div>
				<ReportViewer
					ref={viewerRef}
					data={data}
					isLoading={isLoading || isFetching}
					isError={isError}
					documentLabel="Laudo"
				/>
			</FormCard>
		</div>
	);
};
